var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09982 11.4997C1.24787 10.0635 0.949507 8.36571 1.26076 6.72511C1.57202 5.0845 2.47148 3.61395 3.79026 2.58959C5.10903 1.56524 6.75639 1.05753 8.423 1.16183C10.0896 1.26612 11.6608 1.97523 12.8416 3.156C14.0224 4.33678 14.7315 5.90799 14.8358 7.5746C14.9401 9.24121 14.4324 10.8886 13.4081 12.2073C12.3837 13.5261 10.9132 14.4256 9.27255 14.7369C7.63195 15.0481 5.93414 14.7498 4.49795 13.8978L4.49796 13.8977L2.12964 14.5744C2.03165 14.6024 1.92796 14.6037 1.82931 14.5781C1.73067 14.5526 1.64065 14.5011 1.56859 14.429C1.49653 14.357 1.44505 14.267 1.41949 14.1683C1.39393 14.0697 1.39521 13.966 1.42321 13.868L2.09987 11.4997L2.09982 11.4997Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 6.85742H10.2863",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 9.14258H10.2863",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.8210b19329d9c0b4bc3b5c2f6cdd147a.svg";
export { ForwardRef as ReactComponent };